import React, { useState, useEffect, useRef } from 'react';
import VanillaTilt from 'vanilla-tilt';
import './Home.css'
import {Typed} from "react-typed"

export default function Home() {
  useEffect(() => {
    const cards = document.querySelectorAll('.card');
    cards.forEach((card) => {
      VanillaTilt.init(card, {
        max: 0,
        speed: 4
      });
    });
  }, []);

  const typedRef = useRef(null);

  useEffect(() => {
    const options = {
      strings: ["Frontend Developer", "Python Programmer", "AI - ML Developer"],
      typeSpeed: 80,
      backSpeed: 80,
      loop:true,
    };

    if (typedRef.current) {
      new Typed(typedRef.current, options);
    }
  }, []);

  const [set_active_nav] = useState(0);
  const scrollToSection = (index) => {
    const sections = document.querySelectorAll('section');
    const targetSection = sections[index];

    if (targetSection) {
      targetSection.scrollIntoView({ behavior: 'smooth' });
      // set_active_nav(index);
    }
  };

  const openInNewTab = (url) => {
    const newWindow = window.open(url, '_blank', 'noopener,noreferrer')
    if (newWindow) newWindow.opener = null
  }
  return (
    <section className="section_outer">
      <div className='home-section'>
      <div className='home-content'>
        <h3>Hey there!, It's Me</h3>
        <h1>Ayush Kumawat</h1>
        <h3>And I'm a <span id="types" ref={typedRef}></span> </h3>
        <div className='card'>
        <p>Welcome to the portfolio website of an aspiring B.Tech student 
          exploring the boundless horizons of Artificial Intelligence and Data Science. With a strong focus on machine 
          learning, I have worked on various projects related to detection, prediction & classification my intrest lies in developing impactful software.
          I've actively participated in hackathons & contributed in open-source projects, achieving recognition 
          and certification as an AI specialist by NVIDIA for deploying projects on Jetson Nano.</p>
        </div>
        <div className="social-media">
          <a onClick={() => openInNewTab('https://www.linkedin.com/in/ayush-kumawat/')}><i className="fa-brands fa-linkedin-in"></i></a>
          <a onClick={() => openInNewTab('https://www.github.com/Ayushkumawat')}><i className="fa-brands fa-github"></i></a>
          <a onClick={() => openInNewTab("mailto:ayu.kumawat2002@gmail.com")}><i className="fa-solid fa-envelope"></i></a>
          <a onClick={() => openInNewTab('https://twitter.com/_Ayush_Kumawat')}><i className="fa-brands fa-twitter"></i></a>
        </div>
        <div className='btns'>
        <button onClick={() => scrollToSection(3)} className='btn'>Proficiency Dashboard</button>
        <button onClick={() => scrollToSection(4)} className='btn'>Let's work together !</button>
        </div>
      </div>
      <div className='home-img'>
        <img src={require('../../images/IMG.png')} alt=''></img>
        <span className='circle-spin'></span>
      </div>
      </div>
    </section>
  )
}